import axios from 'axios';
import { pathOr } from 'ramda';

import { loginInfoUrl, customerv6Url } from '../api-urls';

// const SUBSCRIPTION_EXPIRED_CODE = 'SUBSCRIPTION_EXPIRED';
// const TRIAL_SUBSCRIPTION_EXPIRED_CODE = 'ALERT_TRIAL_SUBSCRIPTION_EXPIRED';

const loginInfoRequest = (id, token) => ({
  url: `${loginInfoUrl}?customerId=${id}&token=${token}`,
  method: 'get'
});

const getCustomersId = ({id, token}) => ({
  url: `${customerv6Url}?buyerId=${id}`,
  method: 'get',
  headers: { 'access-token': token },
});

const getCustomersIdWithDocument = ({id, token, document}) => ({
  url: `${customerv6Url}?buyerId=${id}&document=${document}`,
  method: 'get',
  headers: { 'access-token': token },
});

// const hasSubscriptionExpiredWarning = warnings => {
//   return warnings.some(warning => {
//     return (
//       warning.code === SUBSCRIPTION_EXPIRED_CODE || warning.code === TRIAL_SUBSCRIPTION_EXPIRED_CODE
//     );
//   });
// };

export const getCustomersList = async (customer) => {
  try {    
    const { data } = await axios(getCustomersId(customer));

    return data;
  } catch (error) {
    console.error(`Error in login-info, get customers with id <${{...customer}}>`, error);
    return {};
  }
}

export const getCustomersListFiltered = async (customer) => {
  try {    
    const { data } = await axios(getCustomersIdWithDocument(customer));
    return data;
  } catch (error) {
    console.error(`Error in login-info, get customers <${{...customer}}>`, error);
    return {};
  }
}


export default async ({ id, token }) => {
  try {
    const { data } = await axios(loginInfoRequest(id, token));

    const {
      customer: customerResult,
      // customerprime: primeResult,
      region: regionResult
    } = data;

    const customerType = pathOr({}, ['result', 'type'], customerResult);
    const nickname =
      customerType.pf === undefined
        ? pathOr('', ['pj', 'corporateName'], customerType)
        : pathOr('', ['pf', 'nickname'], customerType);
    const email = pathOr('', ['result', 'email'], customerResult);
    const constraints = pathOr([], ['result', '_constraints'], customerResult);
    const privacyPolicyV1 = pathOr(false, ['result', 'optIn', 'privacyPolicyV1'], customerResult);

    const region = pathOr('', [0, 'result', 'b2wRegion'], regionResult);

    const isPrime = pathOr('', ['result', 'hasPrime'], customerResult);
    // const isPrime =
    //   pathOr('', ['details', 'status'], primeResult) === 200 &&
    //   !hasSubscriptionExpiredWarning(pathOr([], ['result', '_warnings'], primeResult));

    const isCorporateCustomer = customerType.pf === undefined;

    return { nickname, email, isPrime, region, constraints, isCorporateCustomer, privacyPolicyV1 };
  } catch (error) {
    console.error(`Error in login-info with id <${id}> and token <${token}>`, error);
    return {};
  }
};
